import { MESSAGE_TYPE, MESSAGE_STATUS } from "./enums.js";
import useUserStore from '../store/userStore.js';
import i18n from '@/i18n';

function previewContent(m) {
    let content = i18n.t('chat.unsupportedType');
    try {
        if (m.type == MESSAGE_TYPE.IMAGE) {
            content = i18n.t('chat.previewImage');
        } else if (m.type == MESSAGE_TYPE.VIDEO) {
            content = i18n.t('chat.previewVideo');
        } else if (m.type == MESSAGE_TYPE.MEDIA_ALBUM) {
            try {
                const data = JSON.parse(m.content || '{}');
                const cap = (data.caption || '').trim();
                content = cap ? `[图文] ${cap}` : '[图文]';
            } catch (e) {
                content = '[图文]';
            }
        } else if (m.type == MESSAGE_TYPE.FILE) {
            content = i18n.t('chat.previewFile') + ' ' + JSON.parse(m.content).name;
        } else if (m.type == MESSAGE_TYPE.AUDIO) {
            content = i18n.t('chat.previewVoice') + ' ' + JSON.parse(m.content).duration + '"';
        } else if (m.type == MESSAGE_TYPE.USER_CARD) {
            content = i18n.t('chat.previewUserCard') + ' ' + JSON.parse(m.content).nickName;
        } else if (m.type == MESSAGE_TYPE.GROUP_CARD) {
            content = i18n.t('chat.previewGroupCard') + ' ' + JSON.parse(m.content).groupName;
        } else if (m.type == MESSAGE_TYPE.STICKER) {
            content = i18n.t('chat.previewSticker') + ' ' + JSON.parse(m.content).name;
        } else if (m.type == MESSAGE_TYPE.MERGE_FORWARD) {
            const n = JSON.parse(m.content).messages.length;
            content = i18n.t('chat.mergeForwardCount', { n });
        } else if (m.type == MESSAGE_TYPE.ACT_RT_VOICE) {
            content = i18n.t('chat.voiceCallTag');
        } else if (m.type == MESSAGE_TYPE.ACT_RT_VIDEO) {
            content = i18n.t('chat.videoCallTag');
        } else if (m.type == MESSAGE_TYPE.SYSTEM_MESSAGE) {
            content = m.title;
        } else if (m.type == MESSAGE_TYPE.TEXT || m.type == MESSAGE_TYPE.RECALL) {
            content = m.content;
        } else if (m.type == MESSAGE_TYPE.TIP_TEXT) {
            content = displayContent(m.content);
            const userStore = useUserStore();
            content = content.replace(/#\{([^:]+):(\d+)\}/g, (match, displayName, userId) => {
                if (userStore.userInfo.id == userId) {
                    return i18n.t('chat.you');
                }
                return displayName;
            });
        }
    } catch (e) {
        console.log("message:", m, e);
    }
    return content;
}

/**
 * TIP_TEXT 展示文案：若 content 为 key+params JSON 则按当前语言渲染，否则返回原 content（历史纯字符串）
 * @param {string} content - 存库的 content
 * @returns {string} 展示用文案
 */
function displayContent(content) {
    try {
         // 兼容旧版本
        if (!content ||!content.trim().startsWith('{')) {
            return content;
        }
        // 转化
        const obj = JSON.parse(content);
        if (obj && obj.key) {
            return i18n.t(obj.key, obj.params) || content;
        }
    } catch (e) {
        console.log("displayContent error,message:", content, e);
    }
    return content;
}

/**
 * 从消息列表中按时间顺序提取可预览的图片 URL（IMAGE、RICH_TEXT 内嵌图、MEDIA_ALBUM）
 */
function collectImageUrlsFromMessages(messages) {
    const urls = [];
    if (!messages || !messages.length) {
        return urls;
    }
    const sorted = messages
        .filter(m => !m.deleted
            && m.status !== MESSAGE_STATUS.RECALL
            && m.type !== MESSAGE_TYPE.RECALL)
        .sort((a, b) => {
            if (a.seqNo !== b.seqNo) {
                return a.seqNo - b.seqNo;
            }
            return (a.sendTime || 0) - (b.sendTime || 0);
        });
    for (const m of sorted) {
        try {
            if (m.type === MESSAGE_TYPE.IMAGE) {
                const data = typeof m.content === 'string' ? JSON.parse(m.content) : m.content;
                if (data && data.originUrl) {
                    urls.push(data.originUrl);
                }
            } else if (m.type === MESSAGE_TYPE.MEDIA_ALBUM || m.type === MESSAGE_TYPE.RICH_TEXT) {
                const data = typeof m.content === 'string' ? JSON.parse(m.content) : m.content;
                // 图文相册：优先 items
                if (data && Array.isArray(data.items) && data.items.length) {
                    for (const item of data.items) {
                        if (!item || item.type === 'video') continue;
                        const url = item.originUrl || item.thumbUrl;
                        if (url) urls.push(url);
                    }
                    continue;
                }
                // 历史富文本：blocks 内嵌图
                const blocks = (data && data.blocks) || [];
                for (const block of blocks) {
                    if (block.type === 'image') {
                        const url = block.originUrl || block.url;
                        if (url) {
                            urls.push(url);
                        }
                    }
                }
            }
        } catch (e) {
            console.log('collectImageUrlsFromMessages skip message:', m, e);
        }
    }
    return urls;
}

export {
    previewContent,
    displayContent,
    collectImageUrlsFromMessages
};
